<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  label-width="100px"
                  class="demo-ruleForm">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="消息标题">
                        {{ formData.title }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="所属国家">
                        {{ countryName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="消息类型" prop="notice_type">
                        {{ noticeType }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="所属大学">
                        {{ formData.school_name }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--接收人 begin-->
                  <el-row style="display: none">
                    <el-col :span="20">
                      <el-form-item label="接收人">
                        <table v-for="item in receiverGroup" :key="item.id">
                          <tr>
                            <td valign="top" width="90">
                              {{ item.name }}
                            </td>
                            <td>
                              <p class="small">
                                {{ crewsSpan(item.crews) }}
                              </p>
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="接收人">
                        <table v-for="item in miniData" :key="item.id">
                          <tr>
                            <td valign="top" width="90">
                              {{ item.name }}:
                            </td>
                            <td>
                              <p class="small">
                                <span v-for="user in item.users" v-if="formData.mini_users.indexOf(user.userid)!==-1">{{ user.truename }} &nbsp;</span>
                              </p>
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--接收人 end-->
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="详细内容" class="rules-wrap">
                        <div v-html="formData.content"></div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16">
                      <el-form-item>
                        <router-link :to="{ name: 'noticeList' }">
                          <el-button size="small" type="primary">返回</el-button>
                        </router-link>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      ds: {},
      formData: {
        id: this.$route.params.id || 0,
        title: '',
        country: '',
        school_id: null,
        school_name: '',
        notice_type: '',
        receiver: [],
        mini_group: [],
        mini_users: [],
        content: '',
        sendMessage: 0,
      },
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  methods: {
    crewsSpan(teachers) {
      let span = [];
      teachers.forEach((item) => {
        if (!item.testkey) {
          span.push(item.truename);
        }
      });

      return span.join('、');
    },
    fetchDictData() {
      this.$http
        ._get({
          url: '/index/europe_notice/dictData'
        })
        .then(({ data }) => {
          this.ds = data;
        });
    },
    initFormData() {
      this.$http._get({
        url: '/index/europe_notice/getNotice',
        data: { id: this.$route.params.id }
      }).then((res) => {
        if (res.result === 0) {
          this.formData = res.data;
        }
      }).catch(() => {
        // this.$router.go(-1);
      });
    }
  },
  mounted() {
    this.initFormData();
    this.fetchDictData();
  },
  computed: {
    noticeType() {
      if (typeof this.ds.types !== 'undefined' && this.ds.types.length > 0) {
        let arr = this.ds.types.filter((t) => {
          return t.id === this.formData.notice_type;
        });
        return arr ? (arr[0].name || '') : '';
      }
      return '';
    },
    countryName() {
      if (typeof this.ds.country !== 'undefined' && this.ds.types.length > 0) {
        let arr = this.ds.country.filter((t) => {
          return t.id === this.formData.country;
        });
        return arr ? (arr[0].name || '') : '';
      }
      return '';
    },
    receiverGroup() {
      if (typeof this.ds.types !== 'undefined' && this.ds.types.length > 0) {
        return this.ds.group.filter((g) => {
          return this.formData.receiver.indexOf(g.id) !== -1;
        });
      }
      return [];
    },
    miniData() {
      if (typeof this.ds.types !== 'undefined' && this.ds.types.length > 0) {
        return this.ds.mini_group.filter((g) => {
          return this.formData.mini_group.indexOf(g.id) !== -1;
        });
      }
    },
  }
};
</script>

<style>
  .small {
    font-size: 10px;
    line-height: 160%;
    color: #aaa;
  }
  .quill-editor {
    min-height: 242px;
    max-height: 400px;
    overflow-y: auto;
  }
  .rules-wrap {
    position: relative;
  }
  .rules-wrap .rules-span {
    position: absolute;
    color: #ff0000;
    left: 2px;
    top: 30px;
  }
  .quill-editor .ql-container {
    height: 200px !important;
  }
</style>
